<template>
  <div class="home-dashboard-box">
    <div
      v-for="tile in tileList"
      :id="tile.id"
      :key="tile.id"
      class="home-dashboard-item"
      :class="tile.active ? '' : 'disabled-tile'"
      @click="componentClicked(tile.path)"
    >
      <div class="tile-content">
        <component :is="tile.component" />
      </div>

      <div class="tile-title">
        {{ tile.title }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import AddressesTile from './Addresses/AddressesTile.vue'
import FilesTile from './Files/FilesTile.vue'
import ActivityTile from './Activity/ActivityTile.vue'
import PackagesTile from './Packages/PackagesTile.vue'
import PNDPackagesTile from './PNDPackages/PNDPackagesTile.vue'
import { setScreenLoading } from '@/utils/spinner'

@Component({
  components: {
    AddressesTile,
    FilesTile,
    ActivityTile,
    PackagesTile,
    PNDPackagesTile
  }
})
export default class Home extends Vue {
  private get tileList() {
    return [
      {
        id: 'addresses',
        title: this.$t('addressCorrectionPage.title'),
        path: '/addresses',
        active: true,
        component: AddressesTile
      },
      {
        id: 'files',
        title: this.$t('filesPage.title'),
        path: '/files',
        active: true,
        component: FilesTile
      },
      {
        id: 'packages',
        title: this.$t('packagesPage.title'),
        path: '/packages',
        active: true,
        component: PackagesTile
      },
      {
        id: 'pnd-packages',
        title: this.$t('pndPackages.page.title'),
        path: '/pnd-packages',
        active: true,
        component: PNDPackagesTile
      },
      {
        id: 'activity',
        title: this.$t('activityPage.activityPageTitle'),
        path: '/activity',
        active: true,
        component: ActivityTile
      }
    ]
  }

  componentClicked(componentName: string) {
    setScreenLoading(true)
    setTimeout(() => {
      this.$router.push(`${componentName}`)
    }, 700)
  }
}
</script>

<style lang="scss">

.home-dashboard-box {
  display: grid;
  height: 90%;
  min-height: 90%;
  overflow: auto;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 15px;
}

.home-dashboard-item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: hsl(0, 0%, 100%);
  overflow: hidden;
  &:hover {
    cursor: pointer;
    filter: opacity(1);
    z-index: +10;
    box-shadow: 0 0 50px hsl(250, 100%, 10%);
  }
  .tile-content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
    width: 100%;
    padding: 5px;
    overflow: auto;
  }
  .tile-title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px !important;
    background-color: hsl(0, 0%, 100%);
    box-shadow: 0px 0px 50px hsla(0, 0%, 0%, 0.2);
    font-size: 0.9rem;
    font-weight: bold;
  }
  &.disabled-tile {
    pointer-events: none;
  }
}

#addresses {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
}

#files {
  grid-column: 3;
  grid-row: 1 / 4;
}

#packages {
  grid-column: 4 / 6;
  grid-row: 1 / 3;
}

#pnd-packages {
  grid-column: 1 / 3;
  grid-row: 3;
}

#activity {
  grid-column: 4 / 6;
  grid-row: 3;
}

@media (max-width: 1199px) {
  .home-dashboard-box {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }

  .home-dashboard-item {
    .tile-title {
      height: 18px !important;
      font-size: 0.7rem;
    }
  }

  #addresses {
    grid-column: 1 / 4;
    grid-row: 1 / 3;
  }

  #files {
    grid-column: 1 / 3;
    grid-row: 3 / 5;
  }

  #packages {
    grid-column: 4 / 7;
    grid-row: 1 / 3;
  }

  #pnd-packages {
    grid-column: 3 / 7;
    grid-row: 3;
  }

  #activity {
    grid-column: 3 / 7;
    grid-row: 4;
  }
}

@media (max-width: 767px) {
  .home-dashboard-box {
    height: 95%;
    min-height: 95%;
    grid-template-columns: 1fr;
  }

  .home-dashboard-item {
    .tile-title {
      height: 26px !important;
      font-size: 0.9rem;
    }
  }

  #addresses {
    grid-column: 1;
    grid-row: 1;
    height: 550px;
  }

  #files {
    grid-column: 1;
    grid-row: unset;
    height: 350px;
  }

  #packages {
    grid-column: 1;
    grid-row: 2;
    height: 550px;
  }

  #pnd-packages {
    grid-column: 1;
    grid-row: unset;
    height: 270px;
  }

  #activity {
    grid-column: 1;
    grid-row: unset;
    height: 270px;
  }
}
</style>
